import React from "react";
import '../styles/main.css';
import '../styles/Domain.css';
import { BusinessCenter, House, MonetizationOn, Gavel, Group, Domain, AllInclusive } from "@mui/icons-material";
import { Grow } from "@mui/material";
import { domains, IDomain } from "../data/dataTypes";

const Domains = () => {

  const DomainIcon = (props: any) => {
    switch (props.type) {
      case 'commercial':
        return <BusinessCenter {...props} />;

      case 'family':
        return <House {...props} />;

      case 'fiscality':
        return <MonetizationOn {...props} />;

      case 'penal':
        return <Gavel {...props} />;

      case 'social':
        return <Group {...props} />;

      case 'societes':
        return <Domain {...props} />;

      default:
        return <Gavel {...props} />;
    }
  }

  return (
    <section className="sectionDomains">
      <div className='presentationDomains'>
        {domains.map((dom: IDomain, index: number) => {
          return (
            <div key={dom.id}>
              <Grow in {... {timeout: 800 * index + 1}}>
                <div className="domainCard">
                  <a href={`/domain/${dom.type}`}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                      <DomainIcon type={dom.type} fontSize="large" />
                      <h1 className='titleDom'>{dom.title}</h1>
                    </div>
                    <ul className='detailsDom'>
                      {dom.detailDescription.map((description: {description: string;}, i: number) => {
                        return (
                          <li>
                            <p>{description.description}</p>
                          </li>
                        );
                      })}
                    </ul>
                    <AllInclusive />
                  </a>
                </div>
              </Grow>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Domains;
